module.exports = __webpack_public_path__ + "img/DE00580.56cb912c.png";